import React from 'react';
import PropTypes from 'prop-types';

const ButtonPrimary = ({
    href, target = "_self", label, icon, classes, onClick
}) => {
    if (href) {
        return (
            <a 
                href={href}
                target={target}
                className={'btn btn-primary ' + classes}
                onClick={onClick}
            >
                {label}
                {icon ? <span className='material-symbols-rounded' aria-hidden="true">
                    {icon}
                </span> : null}
            </a>
        );
    } else {
        return (
            <button className={'btn btn-primary ' + classes}>
                {label}
                {icon ? 
                    <span className='material-symbols-rounded' aria-hidden="true">
                        {icon}
                    </span> : null    
                }
            </button>
        );
    }
};

ButtonPrimary.propTypes = {
    label: PropTypes.string.isRequired,
    href: PropTypes.string,
    target: PropTypes.string,
    icon: PropTypes.string,
    classes: PropTypes.string,
    onClick: PropTypes.func,
};

const ButtonOutline = ({
    href, target = "_self", label, icon, classes, onClick
}) => {
    if (href) {
        return (
            <a 
                href={href}
                target={target}
                className={'btn btn-outline ' + classes}
                onClick={onClick}
            >
                {label}
                {icon ? <span className='material-symbols-rounded' aria-hidden="true">
                    {icon}
                </span> : null}
            </a>
        );
    } else {
        return (
            <button className={'btn btn-primary ' + classes}>
                {label}
                {icon ? 
                    <span className='material-symbols-rounded' aria-hidden="true">
                        {icon}
                    </span> : null    
                }
            </button>
        );
    }
};

ButtonOutline.propTypes = {
    label: PropTypes.string.isRequired,
    href: PropTypes.string,
    target: PropTypes.string,
    icon: PropTypes.string,
    classes: PropTypes.string,
    onClick: PropTypes.func,
};

export{ButtonPrimary,ButtonOutline};